import { DefaultAnswerEnum } from '@ulysses-inc/harami_api_client'
import { isNullish } from '~/utils/isNullish'
import type { TextRule } from './textRule'
import type { QuestionBase } from '../question'

export type TextQuestion = QuestionBase<'text'> & {
  rule: TextRule
  defaultAnswer?: {
    type: DefaultAnswerEnum
    // 製品マスターに該当する値がない場合は null になる
    value: string | null
  }
}

const isProductMasterAnswer = (question: TextQuestion): boolean => {
  if (question.defaultAnswer?.type === DefaultAnswerEnum.ProductMaster) {
    return true
  }
  return false
}

/**
 * 製品マスターに該当するデータがない場合を判定
 * - defaultAnswer.value が null, undefined, または空文字列の場合
 */
const hasNoProductMasterData = (question: TextQuestion): boolean => {
  if (
    question.defaultAnswer?.type === DefaultAnswerEnum.ProductMaster &&
    (isNullish(question.defaultAnswer.value) ||
      question.defaultAnswer.value === '')
  ) {
    return true
  }
  return false
}

export const TextQuestion = {
  isProductMasterAnswer,
  hasNoProductMasterData,
}
